import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'VColorPickerField',
  props: {
    modelValue: null,
    label: null,
    description: null,
    disabled: { type: Boolean },
    fallbackColor: null,
    colors: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue?: string;
  label?: string;
  description?: string;
  disabled?: boolean;
  fallbackColor?: string;
  colors?: string[];
};

const fallbackHexColor = "#C62828";
const defaultColorOptions = [
  "#000000",
  "#434343",
  "#666666",
  "#980000",
  "#C62828",
  "#E67C00",
  "#F9A825",
  "#2E7D32",
  "#00838F",
  "#1565C0",
  "#283593",
  "#6A1B9A",
];





function normalizeHexColor(value?: string | null, fallback = fallbackHexColor) {
  const cleanedValue = (value || "")
    .trim()
    .replace(/[^0-9a-fA-F]/g, "")
    .slice(0, 6)
    .toUpperCase();

  if (cleanedValue.length === 6) {
    return `#${cleanedValue}`;
  }

  const fallbackValue = (fallback || fallbackHexColor)
    .trim()
    .replace(/[^0-9a-fA-F]/g, "")
    .slice(0, 6)
    .toUpperCase();

  return fallbackValue.length === 6
    ? `#${fallbackValue}`
    : fallbackHexColor;
}

const resolvedFallbackColor = computed(() =>
  normalizeHexColor(props.fallbackColor, fallbackHexColor)
);

const nativeColorValue = computed(() =>
  normalizeHexColor(props.modelValue, resolvedFallbackColor.value)
);

const colorOptions = computed(() => {
  const normalized = (props.colors || defaultColorOptions)
    .map((color) => normalizeHexColor(color, resolvedFallbackColor.value));

  return normalized.filter((color, index) => normalized.indexOf(color) === index);
});

function emitNormalizedColor(value: string) {
  emit("update:model-value", normalizeHexColor(value, resolvedFallbackColor.value));
}

function selectPresetColor(color: string) {
  if (props.disabled) {
    return;
  }

  emitNormalizedColor(color);
}

return { __sfc: true,fallbackHexColor, defaultColorOptions, props, emit, normalizeHexColor, resolvedFallbackColor, nativeColorValue, colorOptions, emitNormalizedColor, selectPresetColor }
}

})